module.exports = __webpack_public_path__ + "assets/img/pizza_1.2bac5b85.png";